import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.scss']
})
export class ConsentDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  isChecked = false;
  noticeText = '';
  privacyContent: string = '';

  @ViewChild('scrollContainer') private readonly scrollContainer?: ElementRef<HTMLElement>;
  private readonly destroy$ = new Subject<void>();

  constructor(private http: HttpClient, public dialogRef: MatDialogRef<ConsentDialogComponent>) { }

  ngOnInit(): void {
    // this.http.get('assets/privacy-notice.html', { responseType: 'text' })
    //   .subscribe(data => {
    //     this.privacyContent = data;
    //   });

      const consent = sessionStorage.getItem('userConsent');
    if (consent) {
      this.isChecked = consent === 'true';
    }
  }

  ngAfterViewInit(): void {
    const el = this.scrollContainer?.nativeElement;
    if (!el) return;

    queueMicrotask(() => (el.scrollTop = 0));
    requestAnimationFrame(() => (el.scrollTop = 0));
    requestAnimationFrame(() => (el.scrollTop = 0));

    this.dialogRef
      .afterOpened()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        setTimeout(() => (el.scrollTop = 0), 0);
        requestAnimationFrame(() => (el.scrollTop = 0));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  

  onAgree() {
    if (this.isChecked) {
      sessionStorage.setItem('userConsent', 'true');
      this.dialogRef.close(true);
    }
  }

  onCancel() {
    sessionStorage.setItem('userConsent', 'false');
    this.dialogRef.close(false);
  }

}
